<template>
  <div>
    <div v-if="!confirmed || !user || state === 'migrationExtras'">
      <authentication />
    </div>
    <div v-else>
      <preferences />
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState } from "vuex";
import Authentication from "@/components/Authentication.vue";
import Preferences from "@/components/Preferences.vue";
export default {
  name: "Account",
  components: {
    Authentication,
    Preferences
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed"])
  },
};
</script>

<style lang="scss">
</style>
